import { render, staticRenderFns } from "./ModalFundotercoper.vue?vue&type=template&id=257e35b7&"
import script from "./ModalFundotercoper.vue?vue&type=script&lang=js&"
export * from "./ModalFundotercoper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports